(function(){
function ready(fn){ if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);} }
function initCF(root){
if(!root||root.__ehcf){return;} root.__ehcf=true;
var vp=root.querySelector('.eh-cf__viewport');
var cards=[].slice.call(root.querySelectorAll('.eh-cf__card'));
var dots=[].slice.call(root.querySelectorAll('.eh-cf__dot'));
var n=cards.length; if(!n){return;}
var active=0, timer=null, DUR=2400;
function mob(){return window.matchMedia('(max-width:768px)').matches;}
function cfg(){return mob()?{sp:150,dz:150,ang:34,sc:0.20,op:0.34,range:2}:{sp:238,dz:230,ang:38,sc:0.16,op:0.26,range:3};}
function wrap(d){d=d%n;if(d>n/2){d-=n;}if(d<-n/2){d+=n;}return d;}
var near=false;
function hydrate(card){
/* EH SPEED 2026-09-11: data-src の画像を必要になった時だけ読む（featured-lookbook.liquid 参照） */
var img=card.__ehimg||(card.__ehimg=card.querySelector("img[data-src]"));
if(!img||!img.getAttribute("data-src")){return;}
var ss=img.getAttribute("data-srcset");if(ss){img.setAttribute("srcset",ss);img.removeAttribute("data-srcset");}
img.setAttribute("src",img.getAttribute("data-src"));img.removeAttribute("data-src");card.__ehimg=null;
}
function render(){
var c=cfg();
for(var i=0;i<n;i++){
var p=wrap(i-active),ap=Math.abs(p),card=cards[i];
if(near&&ap<=c.range+1){hydrate(card);}
if(ap>c.range){
card.style.opacity='0';card.style.pointerEvents='none';card.style.zIndex='0';
card.style.transform='translate(-50%,-50%) translateX('+((p>0?1:-1)*(c.range+1)*c.sp)+'px) translateZ(-'+((c.range+1)*c.dz)+'px) scale(.4)';
card.classList.remove('is-active');continue;
}
var tx=p*c.sp,tz=-ap*c.dz,ry=-p*c.ang,sc=Math.max(1-ap*c.sc,.5),op=Math.max(1-ap*c.op,0);
card.style.transform='translate(-50%,-50%) translateX('+tx+'px) translateZ('+tz+'px) rotateY('+ry+'deg) scale('+sc+')';
card.style.opacity=String(op);card.style.zIndex=String(100-ap);card.style.pointerEvents='auto';
card.classList.toggle('is-active',p===0);
}
for(var d=0;d<dots.length;d++){dots[d].classList.toggle('is-active',d===active);}
}
function go(dir){active=(active+dir+n)%n;render();}
function to(i){active=((i%n)+n)%n;render();}
function start(){stop();timer=setInterval(function(){go(1);},DUR);}
function stop(){if(timer){clearInterval(timer);timer=null;}}
function bump(){start();}
cards.forEach(function(card,i){card.addEventListener('click',function(){if(root.__swiped){return;}to(i);bump();});});
dots.forEach(function(dot,i){dot.addEventListener('click',function(){to(i);bump();});});
var prev=root.querySelector('.eh-cf__nav--prev'),next=root.querySelector('.eh-cf__nav--next');
if(prev){prev.addEventListener('click',function(){go(-1);bump();});}
if(next){next.addEventListener('click',function(){go(1);bump();});}
var sx=0;
vp.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;root.__swiped=false;},{passive:true});
vp.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){root.__swiped=true;go(dx<0?1:-1);bump();setTimeout(function(){root.__swiped=false;},60);}});
var md=false,mxx=0;
vp.addEventListener('mousedown',function(e){md=true;mxx=e.clientX;root.__swiped=false;});
window.addEventListener('mouseup',function(e){if(!md){return;}md=false;var dx=e.clientX-mxx;if(Math.abs(dx)>50){root.__swiped=true;go(dx<0?1:-1);bump();setTimeout(function(){root.__swiped=false;},60);}});
if(!('ontouchstart' in window)){
var stage=root.querySelector('.eh-cf__stage');
stage.addEventListener('mousemove',function(e){var r=stage.getBoundingClientRect();var nx=(e.clientX-r.left)/r.width-0.5,ny=(e.clientY-r.top)/r.height-0.5;vp.style.setProperty('--rx',(ny*-5).toFixed(2)+'deg');vp.style.setProperty('--ry',(nx*6).toFixed(2)+'deg');});
stage.addEventListener('mouseleave',function(){vp.style.setProperty('--rx','0deg');vp.style.setProperty('--ry','0deg');});
}
var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(render,150);});
/* EH SPEED v5 2026-09-11（Astra R3）: 画像はページが組み上がった後（ローダーが退いた後）に IntersectionObserver を始め、セクションが800px手前に来たら読む。読み込み途中に監視を始めると、スライダーが組み上がる前の短いページで遠いのに「近い」と判定され、1.48秒で8本（832KB）が一斉に読まれていた。退いた後に始めれば、スクロールを伴わない位置の変化でも判定される。IntersectionObserverが無い環境は退いた後すぐ読む。 */
function nearOn(){if(near){return;}near=true;render();}
var nearArmed=false;function nearArm(){if(nearArmed){return;}nearArmed=true;if("IntersectionObserver" in window){var nio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){nio.disconnect();nearOn();}});},{rootMargin:"800px 0px"});nio.observe(root);}else{nearOn();}}
if(typeof window.__ehLoaderFadeAt==='number'||!document.querySelector('.fullpageLoader')){nearArm();}else{document.addEventListener('eh:loader-fading',function(){setTimeout(nearArm,50);},{once:true});window.addEventListener('load',nearArm);}
render();
/* EH SPEED 2026-09-11: 画面外でも2.4秒ごとに回り続け、回ってきたカードの画像を読んでいた。画面に入っている間だけ自動送りする（見えている時の動き・速さは同じ）。 */
if("IntersectionObserver" in window){
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){render();start();}else{stop();}});},{rootMargin:"200px 0px"});
io.observe(root);
}else{start();}
}
ready(function(){[].forEach.call(document.querySelectorAll('.eh-cf'),function(r){initCF(r);});});
document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.eh-cf');if(r){r.__ehcf=false;initCF(r);}});
})();
